import { jsx, jsxs } from 'react/jsx-runtime';
import { MenuButtonWrap, MenuButtonLink, Button, TextWrap, Text, ArrowIconWrap, Arrow } from './MenuItem.styles.mjs';
"use strict";
const MenuButton = function MenuButton2({
  children,
  href,
  onClick,
  motif,
  secondary,
  hideOnMobile,
  hideOnDesktop,
  dataTestId,
  openInNewTab
}) {
  return (
    // Wrap needed only so that button doesn't
    // (doesn't what?)
    /* @__PURE__ */
    jsx(MenuButtonWrap, {
      $hideOnMobile: hideOnMobile,
      $hideOnDesktop: hideOnDesktop,
      children: /* @__PURE__ */jsx(MenuButtonLink, {
        $motif: motif,
        $secondary: secondary,
        href,
        target: openInNewTab ? "_blank" : void 0,
        onClick: openInNewTab ? void 0 : onClick,
        "data-test-id": dataTestId,
        children
      })
    })
  );
};
const MenuItem = function MenuItem2({
  children,
  minWidth,
  active,
  showArrow,
  motif,
  hideOnMobile,
  hideOnDesktop,
  ...props
}) {
  return /* @__PURE__ */jsxs(Button, {
    variant: "primary",
    $motif: motif,
    $minWidth: minWidth,
    $active: active,
    $showArrow: showArrow,
    $hideOnMobile: hideOnMobile,
    $hideOnDesktop: hideOnDesktop,
    ...props,
    children: [/* @__PURE__ */jsx(TextWrap, {
      children: /* @__PURE__ */jsx(Text, {
        children
      })
    }), showArrow && /* @__PURE__ */jsx(ArrowIconWrap, {
      $flip: active,
      children: /* @__PURE__ */jsx(Arrow, {})
    })]
  });
};
export { MenuButton, MenuItem };
//# sourceMappingURL=MenuItem.mjs.map
